export const routePaths = [
    { d: "M276 91 H342 L355 80 H438", opacity: 0.38, width: 0.54 },
    { d: "M-14 111 H120 L137 128 H236 L251 113 H302", opacity: 0.52, width: 0.84 },
    { d: "M-18 145 H91 L108 163 H213 L230 178 H438", opacity: 0.4, width: 0.62 },
    { d: "M-16 198 H68 L85 215 H155", opacity: 0.34, width: 0.5 },
    { d: "M112 221 H174 L190 239 H294 L310 221 H438", opacity: 0.5, width: 0.78 },
    { d: "M-18 267 H79 L96 250 H192 L208 233 H308 L325 251 H438", opacity: 0.38, width: 0.64 },
    { d: "M46 174 H132 L149 188 H242 L259 173 H356", opacity: 0.4, width: 0.62 },
    { d: "M-18 227 H55 L72 241 H167 L184 226 H277 L294 241 H401", opacity: 0.42, width: 0.66 },
    { d: "M62 275 H145 L162 260 H255 L272 276 H374", opacity: 0.4, width: 0.62 },
    { d: "M-18 302 H81 L98 287 H201 L218 303 H318 L335 288 H438", opacity: 0.38, width: 0.6 },
    { d: "M35 315 H98 L114 296 H239", opacity: 0.48, width: 0.74 },
    { d: "M-12 355 H72 L88 337 H178 L194 319 H284 L300 301 H438", opacity: 0.32, width: 0.56 },
    { d: "M-18 286 H49 L66 300 H142 L159 286 H267", opacity: 0.33, width: 0.54 },
    { d: "M244 317 H338 L355 333 H438", opacity: 0.36, width: 0.58 },
];

export const routeNodes = [
    { cx: 276, cy: 91, radius: 1.4 },
    { cx: 236, cy: 128, radius: 1.1 },
    { cx: 190, cy: 239, radius: 1.3 },
    { cx: 96, cy: 250, radius: 1 },
    { cx: 239, cy: 296, radius: 1.2 },
    { cx: 149, cy: 188, radius: 1.1 },
    { cx: 259, cy: 173, radius: 1.2 },
    { cx: 72, cy: 241, radius: 1 },
    { cx: 184, cy: 226, radius: 1.1 },
    { cx: 294, cy: 241, radius: 1.2 },
    { cx: 162, cy: 260, radius: 1 },
    { cx: 272, cy: 276, radius: 1.1 },
    { cx: 218, cy: 303, radius: 1.2 },
    { cx: 66, cy: 300, radius: 1.1 },
    { cx: 159, cy: 286, radius: 1 },
    { cx: 355, cy: 333, radius: 1.2 },
];

export const routeNodePulseDurationsInSeconds = [
    6.7, 8.9, 7.3, 10.1, 9.4, 7.8, 11.3, 8.4, 10.7, 6.2, 9.8, 8.1,
    11.7, 7.1, 9.2, 10.4, 6.5, 8.6, 11.1, 7.6, 10.9, 8.3, 11.5,
    6.8, 9.6, 7.4, 10.2,
];

export const routeNodePulseDelaysInSeconds = [
    -0.3, -2.8, -5.1, -1.7, -7.6, -3.9, -9.8, -6.4, -0.9, -4.5,
    -8.2, -1.1, -6.9, -3.2, -8.7, -5.6, -2.4, -10.3, -7.4, -4.8,
    -9.4, -2.1, -6.1, -10.7, -3.5, -8.9, -1.4,
];

export const routeNodeRestOpacities = [
    0.2, 0.31, 0.24, 0.35, 0.18, 0.28, 0.22, 0.33, 0.26, 0.19,
    0.3, 0.23, 0.34, 0.21, 0.27, 0.17,
];
